import React from "react";

const BigWhitePlus = () => {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.0177 18.3H17.1077V30.87H11.8577V18.3H0.00765634V13.44H11.8577V0.899998H17.1077V13.44H29.0177V18.3Z"
        fill="white"
      />
    </svg>
  );
};

export default BigWhitePlus;
